import { render } from "./ContentButton.vue?vue&type=template&id=a9419fd0"
import script from "./ContentButton.vue?vue&type=script&lang=js"
export * from "./ContentButton.vue?vue&type=script&lang=js"

import "./ContentButton.vue?vue&type=style&index=0&id=a9419fd0&lang=scss"
script.render = render

export default script